/**
 * SSR safe types
 */
import { hasWindowSupport } from './env';
var w = hasWindowSupport ? window : {};
export var HTMLElement = w.HTMLElement || Object;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/utils/safe-types.js
// module id = RKmb
// module chunks = 0